import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-csq-logo',
  imports: [],
  template: ` <img class="csq-logo ms-1" src="/static/assets/images/CSQ-logo.svg" alt="CSQ" [class]="additionalClasses" /> `,
  styles: [
    `
      .csq-logo {
        height: 16px;
        width: auto;
        vertical-align: middle;
      }
    `,
  ],
})
export class CsqLogoComponent {
  @Input() additionalClasses: string = '';
}
